import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import {
    Button, Modal, FileUpload, Panel,
} from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

const FORM_INITIAL_STATE = {
    windowMessage: '',
    caricandoModale: false,
    fileCaricato: null,
    mostraPannelloErrore: false,
    errorMessage: '',
};


class ModaleUploadFile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...FORM_INITIAL_STATE,
            caricandoModale: false,
            fileCaricato: null,
            mostraPannelloErrore: false,
            errorMessage: '',
        };

        this.initializeComponent();
    }

    componentDidMount() {
        if (this.props.showModal) {
            setTimeout(() => this.fileUpload && findDOMNode(this.fileUpload).click(), 100);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.showModal != this.props.showModal && nextProps.showModal) {
            setTimeout(() => this.fileUpload && findDOMNode(this.fileUpload).click(), 100);
        }
    }

    initializeComponent() {
        this.annulla = this.annulla.bind(this);
        this.updateForm = this.updateForm.bind(this);
        this.controllaUpload = this.controllaUpload.bind(this);
    }

    annulla() {
        this.setState(FORM_INITIAL_STATE, () => this.props.onAnnulla && this.props.onAnnulla());
    }

    updateForm(data) {
        this.setState(data);
    }

    notificaErrore = () => {
        this.setState({ caricandoModale: false });
        SnackbarManager.notifyError('Errore nel caricamento del file!');
    }

    controllaUpload = (res) => {
        this.setState({ caricandoModale: false });
        if (res) {
            if (!res.Success) {
                this.setState({ mostraPannelloErrore: true, errorMessage: res.DetectedProblems });
            } else {
                SnackbarManager.startIndeterminateAsyncTask(res.CorrelationId, 'Importazione in corso');
                this.annulla();
            }
        } else {
            SnackbarManager.notifyError('Errore in importazione file!');
        }
    }

    render() {
        const {
            showModal,
            isLoading,
            urlUpload,
            fileType,
        } = this.props;
        const {
            caricandoModale,
            mostraPannelloErrore,
            errorMessage,
        } = this.state;

        return (
            <Modal show={showModal} onClose={this.annulla} loading={isLoading || caricandoModale} style={{ width: '1000px' }}>
                <Modal.Header>Scegli file da caricare
                </Modal.Header>
                <Modal.Body>
                    <FileUpload
                        url={urlUpload}
                        max={30}
                        onCatch={() => this.notificaErrore()}
                        onChange={() => this.setState({ caricandoModale: true })}
                        onFileUploaded={this.controllaUpload}
                    >
                        <Button ref={r => this.fileUpload = r}>Seleziona file</Button>
                    </FileUpload>
                    {
                        mostraPannelloErrore
                        && (
                            <Panel
                                error
                                title="Errore"
                            >{errorMessage}
                            </Panel>
                        )
                    }
                </Modal.Body>
            </Modal>
        );
    }
}

ModaleUploadFile.propTypes = {
    urlUpload: PropTypes.string,
    fileType: PropTypes.arrayOf(PropTypes.string),
    isLoading: PropTypes.bool,
    onAnnulla: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
};

export default ModaleUploadFile;
